import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class UserProfile extends MongoEntity {
  static override _class = 'UserProfile';
  static override _collectionName = 'user_profiles';

  @Field(type => String) userId!: string;
  @Field(type => String) organizationId!: string;
  @Field(type => String) createdAt!: string;
}
